module.exports = __webpack_public_path__ + "static/c7785de7a9972dadf466d3f6dc8f315710068b6f55b81c663e46465af2586c7e-145ed3b8bdf1fde0aa2b62cb0a7c3ffb.png";